import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import useAuth from 'hooks/useAuth';
import { useRecoilValue } from 'recoil';
import rhpLinkAccountAtom from 'recoil/account/rhpLinkAccount';

export const RHP_GROUPS_KEY = ['account', 'groups'];
const FIFTEEN_MINUTES = 15 * 60 * 1000;

const useRHPGroups = () => {
    const { isAuthenticated, accountLoaded } = useAuth();
    const { Username } = useRecoilValue(rhpLinkAccountAtom);
    return useQuery(
        RHP_GROUPS_KEY,
        () => apiClient.get('/Account/RHPGroups').then(r => r.data),
        {
            staleTime: FIFTEEN_MINUTES,
            refetchInterval: FIFTEEN_MINUTES,
            enabled: isAuthenticated && accountLoaded && !!Username,
        }
    );
};

export default useRHPGroups;
